import React from 'react';
    import {motion, AnimatePresence} from 'framer-motion';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';
    const {FiX, FiMail, FiInstagram} = FiIcons;

    const ContactModal = ({isOpen, onClose}) => {
      return (
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
              onClick={onClose}
            >
              <motion.div
                initial={{opacity: 0, scale: 0.9}}
                animate={{opacity: 1, scale: 1}}
                exit={{opacity: 0, scale: 0.9}}
                className="bg-white rounded-2xl max-w-md w-full p-6"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">Contact Us</h2>
                  <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                    <SafeIcon icon={FiX} className="text-xl" />
                  </button>
                </div>
                <div className="space-y-4 mb-6">
                  <div className="flex items-center space-x-3">
                    <SafeIcon icon={FiMail} className="text-purple-600" />
                    <span className="text-gray-700">hi@chaldeanlink.com</span>
                  </div>
                  <a 
                    href="https://instagram.com/chaldeanlink" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="flex items-center space-x-3 text-purple-600 hover:text-purple-700 transition-colors"
                  >
                    <SafeIcon icon={FiInstagram} className="text-lg" />
                    <span>@chaldeanlink</span>
                  </a>
                </div>
                <div className="flex justify-end">
                  <button
                    onClick={onClose}
                    className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
                  >
                    Close
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      );
    };

    export default ContactModal;